export enum TravelModeEnum {
    /**
     * walking via pedestrian paths & sidewalks (where available)
     */
    WALKING = 'WALKING',
    /**
     * bicycling via bicycle paths & preferred streets (where available).
     */
    BICYCLING = 'BICYCLING',
    /**
     * indicates distance calculation using the road network
     */
    DRIVING = 'DRIVING',
}
